module.exports = __webpack_public_path__ + "media/images/lb/762-ffff9be165bf0d0eb8b7763ed411412d.svg";